import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Sort } from '@angular/material';
import { BehaviorSubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { CustomersService } from 'src/app/services/customer.service';
import { CustomerInsightService } from '../service/customer-insight.service';

@Component({
  selector: 'kt-order-metrics',
  templateUrl: './order-metrics.component.html',
  styleUrls: ['./order-metrics.component.css']
})
export class OrderMetricsComponent implements OnInit {

  @Input() customerId: number;
  @Input() isFinancialYear: boolean = false;
  @Input() currentUser: any = {}
  @Output() dataLoaded = new EventEmitter<void>(); // Event emitter for data load

  orderMetricsData: any;
  private loadingSubject = new BehaviorSubject<boolean>(true);
  loading$ = this.loadingSubject.asObservable().pipe(shareReplay(1)); maximumLastModifiedSince: any;
  minimumLastModifiedSince: any;
  lastOrderLastModifiedSince: any;
  orderByStatusLastModifiedSince: any;
  isOrderByStatusPopulated: boolean = false;
  loading: boolean = true;
  totalOrderRecieved: any = { labels: [], data: [], total: '', reportLabel: '', options: {}, color: [] };
  orderByStatus: any = { labels: [], data: [], total: '', reportLabel: '', options: {}, color: [] };
  mostOrderedProductData: any
  sortedMostOrderedProductData: any;
  mostOrderedCategory: any = { labels: [], data: [], total: '', reportLabel: '', options: {}, color: [] };
  orderCancellationRateData: any = { labels: [], data: [], total: '', reportLabel: '', options: {}, color: [] };
  orderDiscountRateData: any = { labels: [], data: [], total: '', reportLabel: '', options: {}, color: [] };
  lastModifiedSince: any;
  @Input() currency!: string;
  constructor(
    private customerService: CustomersService,
    private customerInsightService: CustomerInsightService,
  ) { }

  ngOnInit(): void {
    if (this.customerId && this.customerId > 0) {
      let debounceTimer: any;

      debounceTimer = setTimeout(() => {
        this.fetchOrderMetrics();
        this.fetchMostOrderedProducts();
      }, 1000); // Debounce delay in milliseconds
    }
  }


  ngOnChanges(changes: SimpleChanges) {
  }

  fetchOrderMetrics(): void {
    this.loadingSubject.next(true);
    this.customerService.getOrderMetrics(this.customerId, this.isFinancialYear).subscribe({
      next: (res: any) => {
        this.orderMetricsData = res && res.data ? res.data : null;
        this.lastModifiedSince = res && res.data && res.data.OrderStatus ? res.data.OrderStatus.LastUpdatedOrderSince : null;
        this.maximumLastModifiedSince = res && res.data && res.data.OrderStatus ? res.data.OrderStatus.MaximumOrderLastModifiedSince : null;
        this.minimumLastModifiedSince = res && res.data && res.data.OrderStatus ? res.data.OrderStatus.MinimumOrderLastModifiedSince : null;
        this.lastOrderLastModifiedSince = res && res.data && res.data.OrderStatus ? res.data.OrderStatus.LastOrderLastModifiedSince : null;
        this.orderByStatusLastModifiedSince = res && res.data && res.data.OrderStatus ? res.data.OrderStatus.OrderByStatusLastModifiedSince : null;

        this.loadingSubject.next(false);
        if (this.orderMetricsData) {

          const orderByStatus = this.orderMetricsData && this.orderMetricsData.OrderStatus? this.orderMetricsData.OrderStatus: null;
          const orderData = res.data.TotalOrderAmountByYear ? res.data.TotalOrderAmountByYear : [];
          const orderByCategory = res.data.ProductByCategory ? res.data.ProductByCategory : [];
          const orderCancellationData = res.data.OrderCancellationPercentage ? res.data.OrderCancellationPercentage : [];
          const orderDiscountData = res.data.TotalDiscountPercentage ? res.data.TotalDiscountPercentage : [];

          this.transformOrderByStatus(orderByStatus);
          let formattedData = this.transformOrderData(orderData);
          this.updateOrderChartData(formattedData);
          formattedData = this.transformOrderByCategoryData(orderByCategory);
          this.updateOrderChartByCategoryData(formattedData);
          this.transformOrderCancellationData(orderCancellationData);
          this.transformOrderDiscountData(orderDiscountData);
          this.dataLoaded.emit();
        }

      },
      error: () => {
        this.loadingSubject.next(false);
        this.dataLoaded.emit();
      }
    });
  }

  fetchMostOrderedProducts(): void {
    this.customerService.getMostOrderedProductsMetrics(this.customerId, this.isFinancialYear).subscribe((res: any) => {
      if (res && res.data) {
        this.mostOrderedProductData = res.data;
        this.sortedMostOrderedProductData = this.mostOrderedProductData;
      }
    })
  }
  private transformOrderData(orderData: any[]): { [key: string]: number } {
    return orderData.reduce((acc: any, item: any) => {
      acc[item.Year] = item.Amount;
      return acc;
    }, {});
  }
  private transformOrderByCategoryData(orderData: any[]): { [key: string]: number } {
    return orderData.reduce((acc: any, item: any) => {
      acc[item.CategoryName] = item.TotalSales;
      return acc;
    }, {});
  }

  private transformOrderCancellationData(orderData: any[]): void {
    let formattedData = orderData.reduce((acc: any, item: any) => {
      acc[item.Year] = parseFloat(item.OrderCancellationRate.replace('%', '').trim());
      return acc;
    }, {})

    this.orderCancellationRateData.labels = Object.keys(formattedData);
    this.orderCancellationRateData.data = [{
      data: Object.values(formattedData),
      color: this.customerInsightService.generateBlueShades(this.orderCancellationRateData.labels.length),
    }]
  }

  private transformOrderDiscountData(orderData: any[]): void {
    let formattedData = orderData.reduce((acc: any, item: any) => {
      acc[item.Year] = parseFloat(item.OrderDiscountPercentage.replace('%', '').trim());
      return acc;
    }, {})

    this.orderDiscountRateData.labels = Object.keys(formattedData);
    this.orderDiscountRateData.data = [{
      data: Object.values(formattedData),
      color: this.customerInsightService.generateBlueShades(this.orderDiscountRateData.labels.length)
    }]
  }
  private updateOrderChartData(formattedData: { [key: string]: number }): void {
    this.totalOrderRecieved.labels = Object.keys(formattedData);
    this.totalOrderRecieved.data = [{
      data: Object.values(formattedData), // Single dataset for the chart
      color: this.customerInsightService.generateBlueShades(this.totalOrderRecieved.labels.length),
    }
    ];
    this.totalOrderRecieved.reportLabel = 'Total Orders by Year';
  }
  private updateOrderChartByCategoryData(formattedData: { [key: string]: number }): void {
    this.mostOrderedCategory.labels = Object.keys(formattedData);
    this.mostOrderedCategory.data = [{
      data: Object.values(formattedData), // Single dataset for the chart
      color: this.customerInsightService.generateBlueShades(this.mostOrderedCategory.labels.length),
    }
    ];
    this.totalOrderRecieved.reportLabel = 'Total Orders by Year';
  }

  transformOrderByStatus(data: any) {
    // Define initial labels and map corresponding keys
    if (!data) {
      return;
    }
    const orderMapping = [
      { label: 'Pending', countKey: 'TotalPendingOrderCount', amountKey: 'TotalPendingOrderAmount' },
      { label: 'Completed', countKey: 'TotalCompleteOrderCount', amountKey: 'TotalCompleteOrderAmount' },
      { label: 'Accepted', countKey: 'TotalAcceptOrderCount', amountKey: 'TotalAcceptOrderAmount' },
      { label: 'Partially Completed', countKey: 'TotalPartialCompleteOrderCount', amountKey: 'TotalPartialCompleteOrderAmount' },
      { label: 'Partially Shipped', countKey: 'TotalPartialShippedOrderCount', amountKey: 'TotalPartialShippedOrderAmount' },
      { label: 'Shipped', countKey: 'TotalShippedOrderCount', amountKey: 'TotalShippedOrderAmount' },
      { label: 'Partially Delivered', countKey: 'TotalPartialDeliveredOrderCount', amountKey: 'TotalPartialDeliveredOrderAmount' },
      { label: 'Closed', countKey: 'TotalClosedOrderCount', amountKey: 'TotalClosedOrderAmount' },
    ];

    // Filter out entries with count = 0
    const filteredData = orderMapping.filter(item => data[item.countKey] > 0);
    this.isOrderByStatusPopulated = filteredData.length > 0 ? true : false;

    // Transform filtered data into chart format
    this.orderByStatus = {
      labels: filteredData.map(item => item.label),
      data: [
        {
          data: filteredData.map(item => data[item.countKey]), // Dataset 1 (Count)
          label: 'COUNT',
          color: '#0095ff',
        },
        {
          data: filteredData.map(item => data[item.amountKey]), // Dataset 2 (Value)
          label: 'VALUE',
          color: '#00e096',
        },
      ],
    };
  }



  sortMostOrderedProductData(sort: Sort) {
    const data = this.mostOrderedProductData.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedMostOrderedProductData = data;
      return;
    }

    this.sortedMostOrderedProductData = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return this.compare(a.ProductName, b.ProductName, isAsc);
        case 'skq':
          return this.compare(a.ProductSqlCode, b.ProductSqlCode, isAsc);
        case 'quant':
          return this.compare(a.TotalQuantity, b.TotalQuantity, isAsc);
        case 'amount':
          return this.compare(a.TotalAmount, b.TotalAmount, isAsc);
        default:
          return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
